<script>
    import { UserStore } from '../stores/UserStore.svelte.js';
</script>

{#if UserStore.loading || UserStore.waiting}
    <aside id="FrontendLoading" class="absolute inset-0 z-[9000] flex items-center justify-center bg-black/50">
        <aside
            class="z-[9001] flex h-[var(--spinner-size)] w-[var(--spinner-size)] items-center justify-center
                rounded-full border-3 border-white/25 border-t-white">
        </aside>
    </aside>
{/if}

<style>
    #FrontendLoading {
        --spinner-size: min(2.5rem, 80vw);
        > aside {
            animation: spin 1s linear infinite;
        }
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>
